'use client';

import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const data = [
  { bracket: '0–30 days', value: 84320, count: 11 },
  { bracket: '31–60 days', value: 47800, count: 7 },
  { bracket: '61–90 days', value: 22400, count: 4 },
  { bracket: '90+ days',   value: 29800, count: 5 },
];

const colors = ['var(--accent)', '#3B82F6', 'var(--amber)', '#EF4444'];

const CustomTooltip = ({ active, payload, label }: { active?: boolean; payload?: { value: number }[]; label?: string }) => {
  if (!active || !payload?.length) return null;
  const item = data.find(d => d.bracket === label);
  return (
    <div className="rounded-lg border shadow-md p-3 text-sm" style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}>
      <p className="font-semibold mb-1" style={{ color: 'var(--foreground)' }}>{label}</p>
      <p style={{ color: 'var(--slate)' }}>Total: <span className="font-semibold tabular-nums" style={{ color: 'var(--foreground)' }}>£{payload[0].value.toLocaleString('en-GB')}</span></p>
      {item && <p style={{ color: 'var(--slate)' }}>Invoices: <span className="font-semibold" style={{ color: 'var(--foreground)' }}>{item.count}</span></p>}
    </div>
  );
};

export default function InvoiceAgingChart() {
  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={data} margin={{ top: 4, right: 4, bottom: 0, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} />
        <XAxis dataKey="bracket" tick={{ fontSize: 10, fill: 'var(--slate)' }} axisLine={false} tickLine={false} />
        <YAxis tickFormatter={(v) => `£${(v/1000).toFixed(0)}k`} tick={{ fontSize: 10, fill: 'var(--slate)' }} axisLine={false} tickLine={false} width={40} />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="value" radius={[4, 4, 0, 0]}>
          {data.map((_, i) => (
            <Cell key={`cell-aging-${i}`} fill={colors[i]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}